var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d2-container',[_c('template',{slot:"header"},[_vm._v("基础用法")]),_c('div',{ref:"wrapper",staticClass:"demo-bs-wrapper"},[_c('div',_vm._l((30),function(n){return _c('div',{key:n,staticClass:"demo-bs-item"},[_vm._v("n : "+_vm._s(n))])}),0)])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }